import { createAction } from '@reduxjs/toolkit';

// TODO: we should change the `native` package pointer to use the action creator instead of the action type
import { ANALYTICS_CREATE_APPLICATION_SUBMITTED } from '@perpay-web/fintech/constants/actionTypes';

export const analyticsApplicationSubmitted = createAction(
    ANALYTICS_CREATE_APPLICATION_SUBMITTED,
);

/**
 * @type {import('@reduxjs/toolkit').ActionCreatorWithOptionalPayload<{
 *  step: string;
 * }>}
 */
export const analyticsCheckoutStepView = createAction(
    'ANALYTICS::CHECKOUT__STEP_VIEW',
);

export const analyticsCheckoutClickExit = createAction(
    'ANALYTICS::CHECKOUT__CLICK_EXIT',
);

export const analyticsCheckoutConfirmOrderClickOrderSummary = createAction(
    'ANALYTICS::CHECKOUT__CONFIRM_ORDER_CLICK_ORDER_SUMMARY',
);

export const analyticsCheckoutConfirmOrderClickPerpayPlus = createAction(
    'ANALYTICS::CHECKOUT__CONFIRM_ORDER_CLICK_PERPAY_PLUS',
);

export const analyticsCheckoutConfirmOrderClickPriceDetails = createAction(
    'ANALYTICS::CHECKOUT__CONFIRM_ORDER_CLICK_PRICE_DETAILS',
);

export const analyticsCheckoutExitConfirmationModalClick = createAction(
    'ANALYTICS::CHECKOUT__EXIT_CONFIRMATION_MODAL_CLICK',
);
